import React, { FC, PropsWithChildren } from 'react';
import { ProductionOrderContentProps } from '@v2/pages/productionOrder/modules/productionOrder/components/ProductionOrderContent';
import { SearchEntity } from '@interfaces/methods';
import { OperationSearchItem, ProductionOrderSearchItem } from '@interfaces/search';
import { connect } from 'react-redux';
import { scale as initialScale } from '@components/frame';
import { font as initialFont } from '@styles/fonts';
import ProductionOrderJobsList from '@v2/pages/productionOrder/modules/productionOrder/components/ProductionOrderJobsList';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { isPhone } from '@helpers';
import { DetailsPageLayoutWrapper } from '@v2/pages/common/components/DetailsPageLayoutWrapper/DetailsPageLayoutWrapper';
import { operationsSearch, productionOrdersSearch } from '@reducers/search';
import { setProductionOrderId, setProductionOrderJobsList, setProductionOrders } from '@reducers/details';
import ColorWrapper from '@styles/colors';
import { ReducerEntityWithLoadingState } from '@v2/pages/common/interfaces';
import { useManageJobContentWrapper } from './hooks/useManageJobContentWrapper';

export interface JobContentWrapperProps extends Omit<ProductionOrderContentProps, 'maxWidth' | 'C' | 'bg' | 'productionOrder'>, PropsWithChildren {
  operationsSearch: SearchEntity<OperationSearchItem>;
  productionOrdersSearch: SearchEntity<ProductionOrderSearchItem>;
  setProductionOrders: (orders: ProductionOrderSearchItem[]) => void;
  setProductionOrderId: (productionOrderId: number) => void;
  title: string;
  productionOrders: ReducerEntityWithLoadingState<OperationSearchItem[]>;
  setProductionOrderJobsList: (jobs: OperationSearchItem[]) => void;
}

export const JobContentWrapper: FC<JobContentWrapperProps> = ({
  productionOrdersSearch,
  operationsSearch,
  loading,
  title,
  children,
  setProductionOrders,
  setProductionOrderId,
  productionOrders,
  setProductionOrderJobsList,
  scale = initialScale,
  font = initialFont,
}) => {
  const { productionOrder, productionOrderDataLoading, showList, activeLevelSubScreenName } = useManageJobContentWrapper({
    productionOrdersSearch,
    operationsSearch,
    setProductionOrders,
    setProductionOrderId,
    productionOrders,
    setProductionOrderJobsList,
  });

  const ListComponent = <ProductionOrderJobsList {...{ productionOrder, loading: loading || productionOrderDataLoading, scale, font, activeLevelSubScreenName }} />;

  const content = (
    <DetailsPageWrapper title={title} shouldUsePhoneLayoutForTitle={showList}>
      {children}
    </DetailsPageWrapper>
  );

  if (isPhone || !showList) {
    return content;
  }

  return <DetailsPageLayoutWrapper scale={scale} ListComponent={ListComponent}>{content}</DetailsPageLayoutWrapper>;
};

export default connect(({ details: { productionOrders } }) => ({ productionOrders }), {
  setProductionOrderJobsList,
  operationsSearch,
  productionOrdersSearch,
  setProductionOrders,
  setProductionOrderId,
})(ColorWrapper(JobContentWrapper));
